import { render } from "./BlockViewer.vue?vue&type=template&id=42b254d5&scoped=true"
import script from "./BlockViewer.vue?vue&type=script&lang=js"
export * from "./BlockViewer.vue?vue&type=script&lang=js"

import "./BlockViewer.vue?vue&type=style&index=0&id=42b254d5&scoped=true&lang=scss"

import exportComponent from "/media/alvian/New Volume14/project/vue js/sfa-nepal-web-report/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42b254d5"]])

export default __exports__